import { render, staticRenderFns } from "./ObjectTab.vue?vue&type=template&id=82fae234&scoped=true"
import script from "./ObjectTab.vue?vue&type=script&lang=ts"
export * from "./ObjectTab.vue?vue&type=script&lang=ts"
import style0 from "./ObjectTab.vue?vue&type=style&index=0&id=82fae234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fae234",
  null
  
)

export default component.exports